import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { ScanLine } from "lucide-react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { API } from "../lib/apiClient";

const MONTHS = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
const YEAR = new Date().getFullYear();

export function QrScanReport({ quotes = [] }) {
  const [scans, setScans] = useState({});
  useEffect(() => { axios.get(`${API}/reports/qr-scans?year=${YEAR}`).then(({ data }) => setScans(data.months || {})).catch(() => {}); }, []);
  const rows = useMemo(() => MONTHS.slice(0, new Date().getMonth() + 1).map((ay, i) => {
    const key = `${YEAR}-${String(i + 1).padStart(2, "0")}`;
    const talep = quotes.filter((q) => q.source === "online_link" && q.channel === "qr" && (q.createdAt || "").startsWith(key)).length;
    return { ay, Tarama: scans[key] || 0, Talep: talep };
  }), [quotes, scans]);
  const total = rows.reduce((a, r) => ({ s: a.s + r.Tarama, t: a.t + r.Talep }), { s: 0, t: 0 });
  const thisMonth = rows[rows.length - 1] || { Tarama: 0, Talep: 0 };
  const rate = total.s ? `%${Math.round((total.t / total.s) * 100)}` : "—";
  return (
    <section className="panel req-source" data-testid="qr-scan-report">
      <div className="panel-head">
        <div><h2><ScanLine size={15} /> QR kartvizit taramaları · {YEAR}</h2><p>QR kodunuzu okutup formu açan kişi sayısı (aynı telefon ay içinde 1 kez sayılır) ve bunlardan kaçının talep gönderdiği.</p></div>
      </div>
      <div className="req-source-sum">
        <div><span>Bu ay tarama</span><strong data-testid="qr-scan-month">{thisMonth.Tarama}</strong></div>
        <div><span>Yıl boyu tarama</span><strong data-testid="qr-scan-total">{total.s}</strong></div>
        <div><span>QR'dan talep</span><strong data-testid="qr-scan-requests">{total.t}</strong></div>
        <div className="ok"><span>Taramadan talebe</span><strong data-testid="qr-scan-rate">{rate}</strong></div>
      </div>
      {total.s > 0 ? (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={rows} margin={{ top: 8, right: 12, left: -18, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="ay" tick={{ fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="Tarama" fill="#f59e0b" radius={[4, 4, 0, 0]} />
            <Bar dataKey="Talep" fill="#1a5fe0" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : <p className="muted small" data-testid="qr-scan-empty">Henüz tarama yok. Yeni QR kodlu kartvizitinizi dağıttıkça burada görünecek.</p>}
    </section>
  );
}
